import React from 'react'
import { IconX } from '@tabler/icons-react'
import classNames from 'classnames'

import { Button } from '@/components/buttons/Button'
import { toast } from '@/components/toasts/toast.helpers'

import { NotificationItem } from './NotificationItem'
import './NotificationToast.scss'

// QCER-989: RTA alerts should read as more urgent than a passive bell row, so the
// toast card carries a sentiment accent (colored left bar + tinted icon) keyed by
// the alert type. The reused NotificationItem is unchanged — this is purely the
// presentational skin at the toast boundary.
const SENTIMENT_MODIFIER = {
  rta_alert_negative: 'notification-toast--negative',
  rta_alert_positive: 'notification-toast--positive',
  rta_alert_informative: 'notification-toast--informative',
}

// QCER-989: the floating top-right presentation of an RTA notification. It reuses
// NotificationItem verbatim so the toast and the bell row share icons, live
// Listen/Chat, cold-join resolution and the post-call "View call" fallback — the
// toast is just the same row in a card that auto-dismisses (sonner `duration`).
//
// `onClickNotification` is rebound to a bare `dismiss` (unlike the bell, where it
// marks the row read). So EVERY way of clearing the toast — the X, the 20s
// timeout, a body click, or working all its action buttons — only closes the
// toast and never marks it read. This is intentional: the bell stays the
// persistent unread record (the ticket keeps RTA in the bell), so acting on the
// ephemeral toast doesn't silently clear the durable one.
export const NotificationToast = ({ notification, toastId }) => {
  const dismiss = () => toast.dismiss(toastId)

  return (
    <div
      className={classNames(
        'notification-toast',
        SENTIMENT_MODIFIER[notification.notificationType]
      )}
      data-testid={`notification-toast-${notification.id}`}
    >
      <Button
        basic
        square
        xs
        icon={<IconX />}
        className="notification-toast__dismiss"
        onClick={dismiss}
        aria-label="Dismiss"
        data-testid={`notification-toast-dismiss-${notification.id}`}
      />
      <NotificationItem notification={notification} onClickNotification={dismiss} />
    </div>
  )
}
